import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

const locations = [
  {
    id: 1,
    name: 'Akurdi',
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&h=400&fit=crop&auto=format'
  },
  {
    id: 2,
    name: 'Nigdi Pradhikaran',
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600&h=400&fit=crop&auto=format'
  },
  {
    id: 3,
    name: 'Sambhaji Chowk',
    image: 'https://images.unsplash.com/photo-1560185007-c5ca9d2c014d?w=600&h=400&fit=crop&auto=format'
  },
  {
    id: 4,
    name: 'Sambhaji Chowk',
    image: 'https://images.unsplash.com/photo-1554995207-c18c203602cb?w=600&h=400&fit=crop&auto=format'
  },
  {
    id: 5,
    name: 'Pimple Saudagar',
    image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=600&h=400&fit=crop&auto=format'
  },
  {
    id: 6,
    name: 'Talwade- Nighoje',
    image: 'https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?w=600&h=400&fit=crop&auto=format'
  },

]

// Duplicate for infinite seamless scroll
const duplicatedLocations = [...locations, ...locations]

const LocationsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container-custom">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Left Text */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="lg:w-1/3 text-center lg:text-left z-10 shrink-0"
          >
            <h2 className="text-3xl md:text-5xl font-heading font-extrabold text-secondary-900 leading-tight">
              Premium Living<br />
              <span className="text-primary-600 mt-2 block">Western Pune</span>
            </h2>
            <p className="mt-4 text-secondary-500 text-sm">
              Explore PG accommodations in Pune's top neighbourhoods.
            </p>
          </motion.div>

          {/* Right Cards Slider */}
          <div className="lg:w-2/3 w-full relative overflow-hidden">
            {/* Fade left */}
            <div
              className="absolute left-0 top-0 bottom-0 w-12 z-10 pointer-events-none"
              style={{ background: 'linear-gradient(to right, white 50%, transparent)' }}
            />
            {/* Fade right */}
            <div
              className="absolute right-0 top-0 bottom-0 w-12 z-10 pointer-events-none"
              style={{ background: 'linear-gradient(to left, white 50%, transparent)' }}
            />

            <motion.div
              animate={{ x: ['0%', '-50%'] }}
              transition={{ repeat: Infinity, ease: 'linear', duration: 30 }}
              className="flex gap-6 w-max py-4"
            >
              {duplicatedLocations.map((loc, idx) => (
                <Link
                  to={`/location/${encodeURIComponent(loc.name.replace(/ /g, '-'))}`}
                  key={`${loc.id}-${idx}`}
                  className="group cursor-pointer flex-shrink-0 block"
                >
                  <div className="w-44 h-32 sm:w-52 sm:h-36 md:w-60 md:h-44 rounded-2xl overflow-hidden shadow-md mb-3 border border-gray-200 bg-gray-200">
                    <img
                      src={loc.image}
                      alt={loc.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      referrerPolicy="no-referrer"
                      crossOrigin="anonymous"
                    />
                  </div>
                  <h4 className="text-center font-heading font-bold text-secondary-700 text-xs sm:text-sm tracking-widest">
                    {loc.name}
                  </h4>
                </Link>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LocationsSection
